// Slick Slider
$.fn.slick_slider = function(options) {

  var $this = $(this); // selector

  var settings = $.extend({
    // These are the defaults.
    dots: true,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 8000,
    lightbox: false,
    lightboxOverlay: 'rgba(0, 0, 0, 0.6)',
    lightboxCloseBackground: '#000000',
  }, options );

  $this.slick({
    dots: settings.dots,
    arrows: settings.arrows,
    infinite: true,
    autoplay: settings.autoplay,
    autoplaySpeed: settings.autoplaySpeed,
    speed: 1000,
    slidesPerRow: 1,
    rows: 1,
    adaptiveHeight: false,
    useTransform: false,
    pauseOnHover:false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    fade: true,
    // lazyLoad: 'ondemand',
    accessibility: false
  }).on('init', function(event, slick, currentSlide, nextSlide){
    // for infinite scroll - autoplay after re initialize slick
    $(this).each(function(){
      var tis = $(this);
      tis.slick('slickPlay');
    });
  }).on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(this).each(function(){
      var current_slick = $(this).find('.slick-active');
      var slick_img = $(this).find('.slick-active .slick-image');
      var slick_img_clone = $(this).find('.slick-cloned .slick-image');
      var tis = $(this);

      // add lazyload class for each slick active
      if(!slick_img.hasClass('lazyloaded')){
        slick_img.addClass('lazyload');
      }

      // cloned add lazyload class
      if(!slick_img_clone.hasClass('lazyloaded')){
        slick_img_clone.addClass('lazyload');
      }

      if(slick_img.hasClass('lazyloaded')){
        tis.slick('slickPlay');
      }else{
        tis.slick('slickPause');
      }
      
      slick_img.on('lazyloaded', function(){
        // current_slick.removeClass('lazyloading');
        current_slick.removeClass('slick-hide');
        // $('.slick-carousel').slick('slickPlay');
        if(this.complete){
          tis.slick('slickPlay');
          slick_img.addClass('completed');
        }else{
          tis.slick('slickPause');
        }
      });
    });
  });

  // Off autoplay on initial load. On autoplay after image has been lazyloaded.
  $this.each(function(){
    var tis = $(this);
    var current_slick = $(this).find('.slick-active');
    var slick_img = $(this).find('.slick-active .slick-image');

    slick_img.addClass('lazyload');

    slick_img.on('lazyloaded', function(){
      slick_img.addClass('completed');
      current_slick.removeClass('slick-hide');
      tis.slick('slickPlay');
    });

    // enable lightbox (make sure you put slick-lightbox class to your <a> tag)
    if(settings.lightbox === true) {
      var venoOptions = {
        // Options
        pinner:    'cube-grid',
        overlayColor: settings.lightboxOverlay,
        closeBackground: settings.lightboxCloseBackground,
        framewidth: 'auto',
        frameheight: 'auto',

        // Callback
        // is called before the venobox pops up, return false to prevent opening;
        cb_pre_open : function(obj){
          tis.slick('slickPause');
        },
        // is called before closing, return false to prevent closing
        cb_pre_close : function(obj, gallIndex, thenext, theprev){
          tis.slick('slickPlay');
        },
      };
      var lightbox_selector = tis.find('.slick-lightbox');
      lightbox_selector.venobox(venoOptions);
    }
  });
};

// Slick Slideshow
$.fn.slick_slideshow = function(options) {

  var $this = $(this); // selector

  var settings = $.extend({
    // These are the defaults.
    dots: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 8000,
    adaptiveHeight: false,
    mobileCenterMode: false,
    mobileCenterPadding: '0',
  }, options );

  $this.slick({
    arrows: settings.dots,
    arrows: settings.arrows,
    autoplay: settings.autoplay,
    autoplaySpeed: settings.autoplaySpeed,
    slidesPerRow: 3,
    rows: 1,
    adaptiveHeight: settings.adaptiveHeight,
    useTransform: false,
    pauseOnHover:false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    fade: true,
    // lazyLoad: 'ondemand',
    accessibility: false,
    // prevArrow: $('.custom-arrowleft'),
    // nextArrow: $('.custom-arrowright'),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesPerRow: 1,
          rows: 1,
          centerMode: (settings.mobileCenterMode === true) ? true : false,
          centerPadding: (settings.mobileCenterMode === true) ? settings.mobileCenterPadding :'0',
          fade: (settings.mobileCenterMode === true) ? false : true,
        }
      },
    ]
  }).on('afterChange', function(event, slick, currentSlide, nextSlide){
    $this.each(function(){
      var current_slick = $(this).find('.slick-active');
      var slick_img = $(this).find('.slick-active .slick-image');
      var slick_img_clone = $(this).find('.slick-cloned .slick-image');
      var tis = $(this);

      // add lazyload class for each slick active
      if(!slick_img.hasClass('lazyloaded')){
        slick_img.addClass('lazyload');
      }

      // cloned add lazyload class
      if(!slick_img_clone.hasClass('lazyloaded')){
        slick_img_clone.addClass('lazyload');
      }
      
      slick_img.on('lazyloaded', function(){
        current_slick.removeClass('slick-hide');
      });
    });
  });

  // Off autoplay on initial load. On autoplay after image has been lazyloaded.
  // Off autoplay on initial load. On autoplay after image has been lazyloaded.
  $this.each(function(){
    var tis = $(this);
    var current_slick = $(this).find('.slick-active');
    var slick_img = $(this).find('.slick-active .slick-image');

    slick_img.addClass('lazyload');

    slick_img.on('lazyloaded', function(){
      slick_img.addClass('completed');
      current_slick.removeClass('slick-hide');
      tis.slick('slickPlay');
    });
  });
};

// Slick Syncing
$.fn.slick_syncing = function(options) {

  var $this = $(this); // selector

  var navForSelector = $this.next('.slick-slider-nav');

  var settings = $.extend({
    // These are the defaults.
    autoplay: false,
    autoplaySpeed: 8000,
    arrows: false,
    lightbox: false,
    lightboxOverlay: 'rgba(0, 0, 0, 0.6)',
    lightboxCloseBackground: '#000000',
  }, options );

  $this.slick({
    arrows: settings.arrows,
    dots: false,
    // asNavFor: '.slick-slider-nav',
    autoplay: settings.autoplay,
    autoplaySpeed: settings.autoplaySpeed,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    useTransform: false,
    pauseOnHover:false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    fade: true,
    // lazyLoad: 'ondemand',
    accessibility: false,
  }).on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(this).each(function(){
      var current_slick = $(this).find('.slick-active');
      var slick_img = $(this).find('.slick-active .slick-image');
      var slick_img_clone = $(this).find('.slick-cloned .slick-image');
      var tis = $(this);
      
      // add lazyload class for each slick active
      if(!slick_img.hasClass('lazyloaded')){
        slick_img.addClass('lazyload');
      }

      // cloned add lazyload class
      if(!slick_img_clone.hasClass('lazyloaded')){
        slick_img_clone.addClass('lazyload');
      }
      
      slick_img.on('lazyloaded', function(){
        current_slick.removeClass('slick-hide');
      });

      $(this).find('.slick-item').addClass('is-active');

      // $(this).next().slick('slickGoTo', currentSlide);
      var currrentNavSlideElem = $(this).next().find('.slick-item[data-slick-item="' + currentSlide + '"]');
      $(this).next().find('.slick-item.is-active').removeClass('is-active');
      $(currrentNavSlideElem).addClass('is-active');
    });
  });

  // Off autoplay on initial load. On autoplay after image has been lazyloaded.
  $this.each(function(){
    var tis = $(this);
    var current_slick = $(this).find('.slick-active');
    var slick_img = $(this).find('.slick-active .slick-image');

    slick_img.addClass('lazyload');

    slick_img.on('lazyloaded', function(){
      slick_img.addClass('completed');
      current_slick.removeClass('slick-hide');
    });

    // enable lightbox (make sure you put slick-lightbox class to your <a> tag)
    if(settings.lightbox === true) {
      var venoOptions = {
        // Options
        pinner:    'cube-grid',
        overlayColor: settings.lightboxOverlay,
        closeBackground: settings.lightboxCloseBackground,
        framewidth: 'auto',
        frameheight: 'auto',
      };
      var lightbox_selector = tis.find('.slick-lightbox');
      lightbox_selector.venobox(venoOptions);
    }
  });

  navForSelector.slick({
    arrows: true,
    dots: false,
    // asNavFor: $this,
    autoplay: false,
    centerMode: false,
    focusOnSelect: false,
    slidesPerRow: 4,
    rows: 1,
    adaptiveHeight: false,
    useTransform: false,
    // cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
    infinite: true,
    // lazyLoad: 'ondemand',
    fade: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesPerRow: 3,
          rows: 1,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesPerRow: 3,
          rows: 1,
        }
      },
    ]
  }).on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(this).each(function(){
      var current_slick = $(this).find('.slick-active');
      var slick_img = $(this).find('.slick-active .slick-image');
      var slick_img_current = $(this).find('.slick-current .slick-image');
      var slick_img_clone = $(this).find('.slick-cloned .slick-image');
      var tis = $(this);

      // add lazyload class for each slick active
      if(!slick_img.hasClass('lazyloaded') || !slick_img_current.hasClass('lazyloaded')){
        slick_img.addClass('lazyload');
      }

      // cloned add lazyload class
      if(!slick_img_clone.hasClass('lazyloaded')){
        slick_img_clone.addClass('lazyload');
      }
      
      slick_img.on('lazyloaded', function(){
        current_slick.removeClass('slick-hide');
      });
    });
  });

  navForSelector.on('click', '.slick-item', function(e) {
    e.preventDefault();
    
    var goToSingleSlide = $(this).data('slick-item');
    $(this).closest('.slick-slider-nav').prev().slick('slickGoTo', goToSingleSlide);
  });

  // Off autoplay on initial load. On autoplay after image has been lazyloaded.
  navForSelector.each(function(){
    var tis = $(this);
    var current_slick = $(this).find('.slick-active');
    var slick_img = $(this).find('.slick-active .slick-image');

    slick_img.addClass('lazyload');

    slick_img.on('lazyloaded', function(){
      slick_img.addClass('completed');
      current_slick.removeClass('slick-hide');
    });
  });
};